import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewPartnerContentComponent } from './new-partner-content/new-partner-content.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PartnerContentPageComponent } from './partner-content-page/partner-content-page.component';
import { CreatePartnerContentComponent } from './create-partner-content/create-partner-content.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { CreateProfileModule } from '../create-profile/create-profile.module';
import { PartnerContentLivePreviewComponent } from '../../common/components/partner-content-live-preview/partner-content-live-preview/partner-content-live-preview.component';
import { AssetLibraryModule } from '../asset-library/asset-library.module';
import { ViewComponent } from './create-partner-content/view/view.component';
import { PagesViewComponent } from './create-partner-content/view/pages-view/pages-view.component';
import { DeleteModule } from '../../common/components/delete/delete.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ViewAttractAdminComponent } from './view-attract-admin/view-attract-admin.component';
import { PipeUtilModule } from '../pipes/pipe-util/pipe-util.module';

@NgModule({
  declarations: [NewPartnerContentComponent, PartnerContentPageComponent, CreatePartnerContentComponent
    , PartnerContentLivePreviewComponent, ViewComponent, PagesViewComponent, ViewAttractAdminComponent],
  imports: [
    NgSelectModule, CommonModule, BrowserModule,FormsModule, ReactiveFormsModule, NgbModule, ColorPickerModule, CreateProfileModule, AssetLibraryModule, DeleteModule, PipeUtilModule
  ],
  exports: [PartnerContentPageComponent, CreatePartnerContentComponent, ViewComponent, PartnerContentLivePreviewComponent, ViewAttractAdminComponent, PagesViewComponent]

})
export class OemPortalModule { }
